import useABTestValue from '@hooks/useABTestValue'

export type UseEnableUserGeolocationIndicator = () => boolean

const useEnableUserGeolocationIndicator: UseEnableUserGeolocationIndicator =
  () => useABTestValue('showGeolocation') === 'show'

export default useEnableUserGeolocationIndicator
